import type { CellClickedEvent } from 'ag-grid-community'
// This is the type of the result of useRouter()
import type { AppRouterInstance } from 'next/dist/shared/lib/app-router-context.shared-runtime'

import { Routes } from '@/app/routes'

/*
 * Click + Shift: Navigate to detail page (same window)
 * Click + Command (Mac) or Ctrl (Windows): Open preview (new window)
 * Regular click: Open preview in container (same window)
 *    - TODO - Make this based on layout config
 */
export const handleTableCellClick = <T>(
  event: CellClickedEvent,
  selectedBond: string | undefined,
  setQueryParams: (params: Partial<T>, description: string) => void,
  queryParam: keyof T,
  router: AppRouterInstance,
  additionalQueryParams?: Partial<T>,
) => {
  // If the row is a group, assume the key is the ISIN
  let eventIsin = event.data?.isin
  if (!eventIsin && event?.node?.key) {
    eventIsin = event?.node?.key
  }
  // Deselect the bond if the same bond is clicked again
  const bondId = selectedBond === eventIsin ? undefined : eventIsin

  if (event.event instanceof MouseEvent && event.event.shiftKey) {
    if (!bondId) {
      return
    }
    const bondDetailUrl = Routes.Research.detail({ bondId })
    router.push(bondDetailUrl)
  } else if (event.event instanceof MouseEvent && event.event.metaKey) {
    if (!bondId) {
      return
    }
    const bondDetailPreviewUrl = Routes.Research.preview({ bondId })
    const width = window.innerWidth
    const height = window.innerHeight
    window.open(
      bondDetailPreviewUrl,
      '_blank',
      `noopener,noreferrer,width=${width},height=${height}`,
    )
  } else {
    setQueryParams(
      {
        [queryParam]: bondId,
        ...additionalQueryParams,
      } as Partial<T>,
      'handleTableCellClick',
    )
  }
}
